<div class="card-container">
  <div class="column-headings">
    <div class="heading">MARKET VALUE</div>
  </div>
  @for (entityAsset of currentPage().data; track entityAsset) {
    <a class="row">
      <app-entity-asset-card [entityAsset]="entityAsset" (cardClicked)="handleCardClicked($event)"></app-entity-asset-card>
    </a>
  }
</div>
